<template>
  <div>
    <nuxt-layout>
      <nuxt-page/>
    </nuxt-layout>
  </div>
</template>
<script setup>

onMounted(() =>{
  testIsMobile()
})
function testIsMobile() {
  if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    const ratio = (window.screen.width / document.body.clientWidth).toFixed(2)
    document.body.style = `transform: scale(${ratio});transform-origin: 0 0;`
    const height = ratio * document.body.clientHeight + 'px'
    document.getElementsByTagName('html')[0].setAttribute('style', `height: ${height}`)
  }
}

</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@300;400;600&family=Nunito+Sans:wght@400;600&display=swap');

</style>
